import { Header, NonCancelableCustomEvent, Tabs, TabsProps } from '@amzn/awsui-components-react';
import { useContext, useEffect, useState } from 'react';
import { RouteComponentProps,useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';

import { HelpPanelTopicOptions } from '../../common/Constants';
import { constants } from '../../common/Localization';
import { MatchParam } from '../../common/types';
import { HelpPanelContext } from '../../contexts/HelpPanelContext';
import AppDependencyPage from '../portfolio-data-asset/AppDependencyPage';
import AppToServerPage from '../portfolio-data-asset/AppToServerPage';
import DBToAppPage from '../portfolio-data-asset/DBToAppPage';
import { InlineEditProvider } from '../portfolio-data-asset/inline-editing/InlineEditContext';
import ServerCommunicationPage from '../portfolio-data-asset/ServerCommunicationPage';

type Props = RouteComponentProps<MatchParam>;

function DependencyPages(props: Props) {
    const { params } = props.match;
    const { portfolioId } = params;
    const location = useLocation();
    const history = useHistory();
    const [ activeTabId, setActiveTabId ] = useState('application-servers');
    const { panelHandler } = useContext(HelpPanelContext);
    
    useEffect(() => {
        panelHandler(HelpPanelTopicOptions.DEPENDENCIES);
    }, [ activeTabId, panelHandler ]);

    useEffect(() => {
        const locationParts: string[] = location.pathname.split('/');
        const activeTab = locationParts[locationParts.length - 1] === 'dependencies' ? 'application-servers' : locationParts[locationParts.length - 1];
        setActiveTabId(activeTab);
    }, [location]);

    const tabDefinition: TabsProps.Tab[] = [
        {
            label: constants.APP_SERVER_TABLE_HEADER,
            id: 'application-servers',
            href: `/portfolio/${portfolioId}/management/dependencies/application-servers`,
            content: <AppToServerPage />
        },
        {
            label: constants.SERVER_COMM_TABLE_HEADER,
            id: 'server-communications',
            href: `/portfolio/${portfolioId}/management/dependencies/server-communications`,
            content: <ServerCommunicationPage />
        },
        {
            label: constants.DB_APP_TABLE_HEADER,
            id: 'database-applications',
            href: `/portfolio/${portfolioId}/management/dependencies/database-applications`,
            content: <DBToAppPage />
        },
        {
            label: constants.APP_DEP_TABLE_HEADER,
            id: 'application-dependencies',
            href: `/portfolio/${portfolioId}/management/dependencies/application-dependencies`,
            content: <AppDependencyPage />
        },
    ];

    const onTabChange = (event: NonCancelableCustomEvent<TabsProps.ChangeDetail>): void => {
        if (event.detail.activeTabHref) {
            history.push(event.detail.activeTabHref);
        }
        setActiveTabId(event.detail.activeTabId);
    };

    return (
        <div data-testid='dependencyPages'>
            <Header variant='h1'>{constants.BREADCRUMB_MANAGE_DEPENDENCIES}</Header>
            <InlineEditProvider>
                <Tabs activeTabId={activeTabId} tabs={tabDefinition} onChange={onTabChange}/>
            </InlineEditProvider>
        </div>
    );
}

export default DependencyPages;
